type PopStateHandler = (event: PopStateEvent) => void;

let handler: PopStateHandler | null = null;
let isInstalled = false;

/**
 * Listens for history moves ahead of the app router, so settings can claim moves across their own entries first.
 * Call it before creating the router: browsers run a window's popstate listeners in the order they were added, capture or not.
 */
export const installSettingsPopStateListener = () => {
  if (isInstalled) return;
  isInstalled = true;
  window.addEventListener("popstate", (event) => handler?.(event));
};

/** Sets the handler that settings' listener runs; null clears it. */
export const setSettingsPopStateHandler = (next: PopStateHandler | null) => {
  installSettingsPopStateListener();
  handler = next;
};
